// extracted by mini-css-extract-plugin
module.exports = {"statusPill":"BasicWizardModal_statusPill__F4HVq","changeYourPlan":"BasicWizardModal_changeYourPlan__a3Zjp"};